export default __webpack_public_path__ + "static/media/flying.3ae7fff2.svg";